const dashboard = {
  // Admin Dashboard
  adminDashboard: 'لوحة تحكم المدير',
  adminSubtitle: 'إدارة المدرسة الخاصة والإشراف',
  therapistDashboard: 'لوحة تحكم المعالج',
  therapistSubtitle: 'الحالات والجلسات ومتابعة التقدم',
  teacherDashboard: 'لوحة تحكم المعلم',
  teacherSubtitle: 'إدارة الفصل والدروس ومتابعة الطلاب',
  // Greeting banner
  pendingApprovals: 'موافقات معلقة',
  newEnrolments: 'تسجيلات جديدة',
  attendanceRecorded: 'تم تسجيل الحضور لليوم — جميع الميزات متاحة.',
  // Admin action buttons
  reviewApprovals: 'مراجعة الموافقات',
  reports: 'التقارير',
  // Therapist action buttons
  newSessionNote: 'ملاحظة جلسة جديدة',
  startAssessment: 'بدء تقييم',
  newLessonPlan: 'خطة درس جديدة',
  markAttendance: 'تسجيل الحضور',
  // Check-in widget
  checkInTitle: 'هل أنت مستعد لبدء يومك؟',
  checkInDescription: 'سجل حضورك لفتح الوصول الكامل للنظام.',
  capturingLocation: 'جارٍ تحديد موقعك...',
  checkInNow: 'تسجيل الحضور',
  checkingIn: 'جارٍ تسجيل الحضور…',
  checkedInTitle: 'تم تسجيل حضورك!',
  checkedInAt: 'تم التسجيل في',
  dontForget: 'لا تنسَ تسجيل الخروج عند المغادرة.',
  checkOut: 'تسجيل الخروج',
  dayComplete: 'اكتمل اليوم!',
  checkedOutAt: 'تم تسجيل الخروج في',
  seeYouTomorrow: 'أراك غداً!',
  checkInToContinue: 'سجل حضورك للمتابعة',
  checkInGateDescription: 'يرجى إكمال تسجيل الحضور اليومي أعلاه للوصول إلى لوحة التحكم الكاملة وسجلات الطلاب وجميع ميزات النظام.',
  // Activity Feed
  activityFeed: 'سجل النشاط',
  livePlatformEvents: 'أحداث المنصة المباشرة',
  // Weekly Attendance
  weeklyAttendanceTrend: 'اتجاه الحضور الأسبوعي',
  past7Days: 'آخر 7 أيام',
  avgPresent: 'متوسط',
  presentPct: 'حاضر',
  present: 'حاضر',
  absent: 'غائب',
  avgDailyPresent: 'متوسط الحضور اليومي:',
  viewFullAttendance: 'عرض سجل الحضور الكامل',
  // Therapist: Caseload
  myCaseload: 'حالاتي',
  activeStudents: '{{count}} طالب نشط',
  goalProgress: 'تقدم الأهداف',
  myStudents: 'طلابي',
  searchStudents: 'البحث عن طالب...',
  classProgress: 'تقدم الفصل',
  nextSession: 'القادمة',
  pageOf: 'صفحة {{current}} من {{total}}',
  prevPage: 'السابق',
  nextPage: 'التالي',
  noStudentsMatch: 'لا يوجد طلاب مطابقين لبحثك.',
  // Student activity menu
  studentMenuTitle: '{{name}} — إجراءات سريعة',
  caseHistory: 'سجل الحالة',
  caseHistoryDesc: 'عرض الخلفية الطبية والنمائية',
  assessment: 'التقييم',
  assessmentDesc: 'إجراء أو مراجعة تقييمات الطالب',
  goalsLessonPlan: 'الأهداف وخطة الدرس',
  goalsLessonPlanDesc: 'إدارة أهداف IEP وتخطيط الدروس',
  progressReport: 'تقرير التقدم',
  progressReportDesc: 'إنشاء أو عرض تقارير التقدم',
  documents: 'المستندات',
  documentsDesc: 'الملفات المرفوعة وأوراق العمل والموارد',
  parentDiary: 'مذكرة ولي الأمر',
  parentDiaryDesc: 'سجل التواصل اليومي مع أولياء الأمور',
  // Therapist: Progress Chart
  multiDomainProgress: 'تقدم متعدد المجالات',
  progressSubtitle: 'درجات التقييم الحالية مقارنة بخط الأساس عبر جميع المجالات',
  subjectProgress: 'تقدم المواد',
  subjectProgressSubtitle: 'الدرجات الحالية مقارنة بخط الأساس عبر جميع المواد',
  baseline: 'خط الأساس',
  current: 'الحالي',
  pts: 'نقطة',
  goal80: 'هدف 80%',
  // Therapist: Session Notes
  recentSessionNotes: 'ملاحظات الجلسات الأخيرة',
  notesNeedFollowUp: '{{total}} ملاحظة — {{challenging}} بحاجة للمتابعة',
  recentLessonNotes: 'ملاحظات الدروس الأخيرة',
  lessonNotesSubtitle: '{{total}} ملاحظة — {{challenging}} بحاجة للانتباه',
  newNote: 'ملاحظة جديدة',
  positive: 'إيجابي',
  neutral: 'محايد',
  challenging: 'صعب',
  markReviewed: 'تعيين كمراجع',
  // Therapist: Upcoming Sessions
  todaysSchedule: 'جدول اليوم',
  sessionsCount: '{{count}} جلسات',
  noSessionsToday: 'لا توجد جلسات اليوم',
  todaysLessons: 'دروس اليوم',
  lessonsCount: '{{count}} دروس',
  noLessonsToday: 'لا توجد دروس اليوم',
  // Faculty Management
  facultyManagement: 'إدارة الكادر',
  facultySubtitle: 'إدارة المعلمين والمعالجين وطاقم الدعم',
  activeFaculty: 'الكادر النشط',
  onLeave: 'في إجازة',
  addTeacher: 'إضافة معلم',
  noTeachersFound: 'لم يتم العثور على معلمين',
  // Metric card labels
  totalStudents: 'إجمالي الطلاب',
  activeTherapists: 'المعالجين النشطين',
  sessionsThisWeek: 'جلسات هذا الأسبوع',
  pendingFollowUps: 'متابعات معلقة',
  totalSessions: 'إجمالي الجلسات',
  totalLessons: 'إجمالي الدروس',
  orgLessonPlans: 'خطط الدروس',
  pendingNotes: 'ملاحظات معلقة',
  avgAttendance: 'متوسط الحضور',
  avgProgress: 'متوسط التقدم',
  goalsAchieved: 'أهداف محققة',
  // Sidebar nav items
  caseload: 'الحالات',
  studentsAttendance: 'حضور الطلاب',
  staffAttendance: 'حضور الموظفين',
  sessions: 'الجلسات',
  assessments: 'التقييمات',
  progress: 'التقدم',
  approvals: 'الموافقات',
  reports: 'التقارير',
  myChild: 'طفلي',
  appointments: 'المواعيد',
  resources: 'المصادر',
  accessControl: 'التحكم بالوصول',
  facultyManagement: 'إدارة الكادر',
  // Incident tracking
  unresolvedIncidentsTitle: '{{count}} حادثة غير محلولة بحاجة للانتباه',
  unresolvedIncidentsDesc: '{{unresolved}} من {{total}} حادثة تحتاج للمتابعة. قم بالمراجعة واتخاذ الإجراء.',
  reviewIncidents: 'مراجعة الحوادث',
  incidentsTracked: 'الحوادث المسجلة',
  unresolvedCount: '{{count}} غير محلولة',
  allResolved: 'تم حل الكل',
  // Announcements
  announcements: 'الإعلانات',
  announcementsSubtitle: 'بث الرسائل إلى الكادر وأولياء الأمور',
  createAnnouncement: 'إنشاء إعلان',
  newAnnouncement: 'إعلان جديد',
  publishAnnouncement: 'نشر الإعلان',
  publishing: 'جارٍ النشر...',
  announcementMessage: 'رسالة الإعلان',
  messagePlaceholder: 'اكتب رسالة الإعلان هنا...',
  recordAudio: 'تسجيل صوتي',
  stopRecording: 'إيقاف التسجيل',
  recordingAudio: 'جارٍ التسجيل...',
  audioRecorded: 'تم تسجيل الرسالة الصوتية',
  selectFaculty: 'اختيار الكادر',
  selectParents: 'اختيار أولياء الأمور',
  selectAll: 'تحديد الكل',
  unselectAll: 'إلغاء تحديد الكل',
  selectedCount: '{{count}} مختار',
  scheduleFor: 'جدولة لـ',
  publishNow: 'نشر الآن',
  scheduleLater: 'جدولة لاحقاً',
  noAnnouncements: 'لا توجد إعلانات بعد',
  noAnnouncementsDesc: 'الإعلانات التي تنشئها ستظهر هنا.',
  searchAnnouncements: 'البحث في الإعلانات...',
  allAnnouncements: 'جميع الإعلانات',
  filterByDate: 'تصفية حسب التاريخ',
  sentTo: 'مُرسل إلى',
  allFaculty: 'كل الكادر',
  allParents: 'كل أولياء الأمور',
  selectedFaculty: '{{count}} من الكادر',
  selectedParents: '{{count}} من أولياء الأمور',
  noRecipients: 'لم يتم اختيار مستلمين',
  publishedBy: 'نُشر بواسطة',
  scheduled: 'مجدول',
  published: 'منشور',
  onDate: 'في',
  announcementCreated: 'تم نشر الإعلان بنجاح!',
  announcementScheduled: 'تمت جدولة الإعلان بنجاح!',
  messageRequired: 'الرسالة مطلوبة',
  recipientsRequired: 'يرجى اختيار مجموعة مستلمين واحدة على الأقل',
  facultyAndParents: 'الكادر وأولياء الأمور',
  facultyOnly: 'الكادر فقط',
  parentsOnly: 'أولياء الأمور فقط',
  audioMessageAttached: 'رسالة صوتية مرفقة',
  deleteAnnouncement: 'حذف الإعلان',
  deleteAnnouncementConfirm: 'هل أنت متأكد من حذف هذا الإعلان؟',
  announcementDeleted: 'تم حذف الإعلان',
  clearDateFilter: 'مسح تصفية التاريخ',
  todayAnnouncements: 'إعلانات اليوم',
  upcomingAnnouncements: 'الإعلانات القادمة',
  previousAnnouncements: 'الإعلانات السابقة',
  noTodayAnnouncements: 'لا توجد إعلانات منشورة اليوم',
  noTodayAnnouncementsDesc: 'الإعلانات المنشورة اليوم ستظهر هنا.',
  noUpcomingAnnouncements: 'لا توجد إعلانات قادمة مجدولة',
  noUpcomingAnnouncementsDesc: 'الإعلانات المجدولة لتواريخ مستقبلية ستظهر في هذا التبويب.',
  noPreviousAnnouncements: 'لا توجد إعلانات سابقة',
  noPreviousAnnouncementsDesc: 'الإعلانات السابقة ستظهر هنا بعد انتهاء تاريخ النشر.',
  byLabel: 'بواسطة',
  audioAnnouncement: 'إعلان صوتي',
  playAudio: 'تشغيل الصوت',
  pauseAudio: 'إيقاف الصوت',
  selectedRecipients: 'المستلمون المختارون',
  noFacultySelected: 'لم يتم اختيار كادر',
  noParentsSelected: 'لم يتم اختيار أولياء أمور',
  scheduleDateTime: 'تاريخ ووقت الجدولة',
  // Read status
  markAsRead: 'تحديد كمقروء',
  read: 'مقروء',
  unread: 'غير مقروء',
  // School Calendar
  schoolCalendar: 'التقويم المدرسي',
  schoolCalendarSubtitle: 'تقويم موحد — الفعاليات والعطلات والمهام',
  calendarView: 'عرض التقويم',
  listView: 'عرض القائمة',
  goToToday: 'اليوم',
  previousMonth: 'الشهر السابق',
  nextMonth: 'الشهر التالي',
  selectDate: 'اختيار تاريخ',
  globalEvents: 'أيام التوعية العالمية',
  schoolHolidays: 'العطلات المدرسية',
  personalTasks: 'مهامي',
  showGlobalEvents: 'إظهار الفعاليات العالمية',
  showSchoolHolidays: 'إظهار العطلات المدرسية',
  showPersonalTasks: 'إظهار مهامي',
  addTask: 'إضافة مهمة',
  addNewTask: 'إضافة مهمة جديدة',
  taskTitle: 'عنوان المهمة',
  taskTitlePlaceholder: 'أدخل عنوان المهمة...',
  dueTime: 'وقت التسليم',
  taskDescription: 'الوصف',
  taskDescriptionPlaceholder: 'أضف وصفاً موجزاً...',
  taskCreated: 'تم إنشاء المهمة بنجاح!',
  taskUpdated: 'تم تحديث المهمة بنجاح!',
  taskCompleted: 'تم تعيين المهمة كمكتملة',
  deleteTask: 'حذف المهمة',
  deleteTaskConfirm: 'هل أنت متأكد من حذف هذه المهمة؟',
  noTasksForDate: 'لا توجد مهام لهذا التاريخ',
  noEventsFound: 'لم يتم العثور على فعاليات',
  allDay: 'طوال اليوم',
  markComplete: 'تعيين كمكتمل',
  markIncomplete: 'تعيين كغير مكتمل',
  recurring: 'يتكرر سنوياً',
  holidayNational: 'وطني',
  holidayRegional: 'إقليمي',
  holidayDiscretionary: 'تقديري',
  impactsAttendance: 'يؤثر على حساب الحضور',
  targetAll: 'الجميع',
  targetTeachers: 'المعلمون',
  targetParents: 'أولياء الأمور',
  // Calendar Settings
  calendarSettings: 'إعدادات التقويم',
  calendarSettingsSubtitle: 'إدارة أيام التوعية العالمية والعطلات المدرسية',
  awarenessEventsMaster: 'قائمة فعاليات التوعية',
  holidayMaster: 'قائمة العطلات',
  awarenessEventsDescription: 'تحديد وإدارة أيام التوعية العالمية التي يتم الاحتفال بها عبر شبكة المدرسة.',
  holidayMasterDescription: 'إدارة العطلات المدرسية التي تؤثر على الجدولة وحسابات الحضور.',
  addEvent: 'إضافة فعالية',
  addHoliday: 'إضافة عطلة',
  editEvent: 'تعديل الفعالية',
  editHoliday: 'تعديل العطلة',
  eventName: 'اسم الفعالية',
  eventDate: 'تاريخ الفعالية (DD/MM)',
  isRecurring: 'يتكرر سنوياً',
  targetAudience: 'الجمهور المستهدف',
  eventDescription: 'الوصف',
  holidayTitle: 'عنوان العطلة',
  startDate: 'تاريخ البداية',
  endDate: 'تاريخ النهاية',
  holidayType: 'نوع العطلة',
  impactsAttendanceLabel: 'يؤثر على حساب الحضور',
  importCsv: 'استيراد CSV',
  csvImportHint: 'رفع ملف CSV بالأعمدة: اسم الفعالية، التاريخ (DD/MM)، متكرر، الجمهور المستهدف، الوصف',
  noEventsDefined: 'لم يتم تحديد أي فعاليات توعية بعد.',
  noHolidaysDefined: 'لم يتم تحديد أي عطلات بعد.',
  eventCreated: 'تم إنشاء الفعالية بنجاح!',
  holidayCreated: 'تم إنشاء العطلة بنجاح!',
  eventUpdated: 'تم تحديث الفعالية بنجاح!',
  holidayUpdated: 'تم تحديث العطلة بنجاح!',
  eventDeleted: 'تم حذف الفعالية بنجاح!',
  holidayDeleted: 'تم حذف العطلة بنجاح!',
  duplicateDateRange: 'يتداخل نطاق التاريخ هذا مع عطلة موجودة',
  noTasksForDay: 'لا توجد مهام لهذا اليوم',
  completedTasks: 'مكتمل',
  pendingTasks: 'قيد الانتظار',
};

export default dashboard;